import {Chart as ChartJS} from 'chart.js';

/** Chart.js plugin that draws a dashed y=x diagonal with an "all barriers failed"
 *  label on a challenged-vs-failed scatter. Points on the diagonal are reports where
 *  every challenged barrier failed (system pass-through). Shared by the Barrier
 *  Effectiveness Health-map Challenged-vs-Failed chart and the Report Clustering
 *  Challenged-vs-Failed chart. */
export const scatterDiagonalPlugin = {
    id: 'scatterDiagonal',
    afterDraw(chart: ChartJS): void {
        const xScale = chart.scales['x'];
        const yScale = chart.scales['y'];
        if (!xScale || !yScale) return;
        const ctx = chart.ctx;
        const area = chart.chartArea;
        const maxVal = Math.min(xScale.max, yScale.max);
        if (maxVal <= 0) return;

        const x0 = xScale.getPixelForValue(0);
        const y0 = yScale.getPixelForValue(0);
        const x1 = xScale.getPixelForValue(maxVal);
        const y1 = yScale.getPixelForValue(maxVal);

        ctx.save();
        ctx.beginPath();
        ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
        ctx.clip();
        ctx.setLineDash([6, 4]);
        ctx.lineWidth = 1;
        ctx.strokeStyle = 'rgba(211, 47, 47, 0.4)';
        ctx.beginPath();
        ctx.moveTo(x0, y0);
        ctx.lineTo(x1, y1);
        ctx.stroke();

        // Label
        ctx.setLineDash([]);
        ctx.fillStyle = 'rgba(211, 47, 47, 0.6)';
        ctx.font = '10px sans-serif';
        ctx.textAlign = 'left';
        const labelX = xScale.getPixelForValue(Math.max(1, maxVal * 0.6));
        const labelY = yScale.getPixelForValue(Math.max(1, maxVal * 0.6));
        ctx.fillText('all barriers failed', labelX + 6, labelY - 6);
        ctx.restore();
    },
};
